import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
var _excluded = ["className"];
import * as React from 'react';
import clsx from 'clsx';
import { jsx as _jsx } from "react/jsx-runtime";
var Hourglass03 = _ref => {
  var {
      className
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "100%",
    height: "100%",
    fill: "none",
    viewBox: "0 0 24 24",
    "data-testid": "hourglass03",
    className: clsx('stroke-current', className)
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M9 18.5h6M6.6 2h10.8c.5601 0 .8401 0 1.054.109a1 1 0 0 1 .437.437C19 2.76 19 3.04 19 3.6v2.0745c0 .4892 0 .7338-.0553.964a2.0015 2.0015 0 0 1-.2394.578c-.1237.2019-.2967.3749-.6426.7208l-2.9313 2.9313c-.396.396-.5941.5941-.6682.8224a.9993.9993 0 0 0 0 .618c.0741.2283.2722.4264.6682.8224l2.9313 2.9313c.3459.3459.5189.5189.6426.7207a2.003 2.003 0 0 1 .2394.5781c.0553.2302.0553.4748.0553.964V20.4c0 .5601 0 .8401-.109 1.054a.9998.9998 0 0 1-.437.437C18.2401 22 17.9601 22 17.4 22H6.6c-.56 0-.84 0-1.054-.109a1 1 0 0 1-.437-.437C5 21.2401 5 20.9601 5 20.4v-2.0745c0-.4892 0-.7338.0553-.964a2.003 2.003 0 0 1 .2394-.5781c.1237-.2018.2967-.3748.6426-.7207l2.9313-2.9313c.396-.396.594-.5941.6682-.8224a.9999.9999 0 0 0 0-.618c-.0741-.2283-.2722-.4264-.6682-.8224L5.9373 7.9373c-.346-.346-.5189-.5189-.6426-.7207a1.9997 1.9997 0 0 1-.2394-.5781C5 6.4083 5 6.1637 5 5.6745V3.6c0-.56 0-.84.109-1.054a1.0001 1.0001 0 0 1 .437-.437C5.76 2 6.04 2 6.6 2Z"
    })
  }));
};
export default Hourglass03;